import produce from 'immer';
import { combineReducers } from 'redux';
import { assignSuccessState, getFailureState, getLoadingState, getSuccessState } from 'utility/redux';
import * as actionTypes from './actionTypes';
import { CancellationPoliciesActionType, CancellationPoliciesStateType } from './types';
import { CLEAR_SELECTED_COMPANY } from 'redux/companies/actionTypes';

const cancellationPoliciesState: CancellationPoliciesStateType = {
  loading: false,
  error: '',
  hasError: false,
  data: null,
};

const companyPolicies = (state = cancellationPoliciesState, action: CancellationPoliciesActionType) => {
  switch (action.type) {
    case actionTypes.CANCELLATION_POLICIES_LOADING:
      return {
        ...state,
        ...getLoadingState(),
      };
    case actionTypes.CANCELLATION_POLICIES_SUCCESS:
      return produce(state, (draft) => {
        draft.data = action.payload.data;
        assignSuccessState(draft, { ...getSuccessState() });
      });
    case actionTypes.CANCELLATION_POLICIES_FAILURE:
      return { ...state, ...getFailureState(action.payload.error) };
    default:
      return state;
  }
};

const combinedReducers = combineReducers({
  companyPolicies,
});

const cancellationPoliciesReducer = (state: any, action: any) => {
  if (action.type === CLEAR_SELECTED_COMPANY) {
    return combinedReducers(undefined, action);
  }

  return combinedReducers(state, action);
};

export default cancellationPoliciesReducer;
